import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["onComplete"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { keysWithMap, nullable } from '@infl-ts/util-io-ts';
import { Box, Dialog, Paper, Slide } from '@mui/material';
import { constVoid, flow } from 'fp-ts/function';
import { forwardRef, useRef, useState } from 'react';
import OnboardingProfileForm from './onboarding-profile-form';
import WelcomeMessage from './welcome-message';
import { jsx as _jsx } from "react/jsx-runtime";
var Transition = /*#__PURE__*/forwardRef(function Transition(props, ref) {
  return /*#__PURE__*/_jsx(Slide, _objectSpread({
    direction: "up",
    ref: ref
  }, props));
});
var pageStateMap = keysWithMap({
  welcomeMessage: 'Welcome',
  profileForm: 'Profile'
});
var PageState = nullable(pageStateMap);

var useProps = function useProps(_ref) {
  var _ref$onComplete = _ref.onComplete,
      onComplete = _ref$onComplete === void 0 ? constVoid : _ref$onComplete,
      rest = _objectWithoutProperties(_ref, _excluded);

  var modalRef = useRef(null);

  var _useState = useState(pageStateMap.map.Welcome),
      page = _useState[0],
      setPage = _useState[1];

  return _objectSpread(_objectSpread({}, rest), {}, {
    page: page,
    onSetPage: function onSetPage(nextPage) {
      if (nextPage === null) onComplete();
      setPage(nextPage);
      if (modalRef.current) modalRef.current.scroll(0, 0);
    },
    modalRef: modalRef
  });
};

export var PureOnboardingModal = function PureOnboardingModal(_ref2) {
  var welcomeMessage = _ref2.welcomeMessage,
      profile = _ref2.profile,
      page = _ref2.page,
      onSetPage = _ref2.onSetPage,
      modalRef = _ref2.modalRef;
  return /*#__PURE__*/_jsx(Dialog, {
    disableEnforceFocus: true,
    PaperProps: {
      sx: {
        width: 1,
        maxWidth: {
          xs: 1,
          md: '70vw'
        },
        height: {
          xs: 1,
          md: '70vh'
        },
        p: 4,
        display: 'flex',
        justifyContent: 'center'
      }
    },
    PaperComponent: function PaperComponent(props) {
      return /*#__PURE__*/_jsx(Paper, _objectSpread(_objectSpread({}, props), {}, {
        ref: modalRef
      }));
    },
    TransitionComponent: Transition,
    open: page !== null,
    fullWidth: true,
    "aria-labelledby": "onboarding-modal",
    "data-element": "Dialog",
    "data-component": "PureOnboardingModal",
    "data-source-file": "onboarding-modal.tsx",
    children: page === pageStateMap.map.Welcome ? /*#__PURE__*/_jsx(Box, {
      sx: {
        display: 'flex',
        maxHeight: 1,
        flexDirection: 'column',
        alignItems: 'center'
      },
      children: /*#__PURE__*/_jsx(WelcomeMessage, {
        message: welcomeMessage,
        onContinue: function onContinue() {
          return onSetPage(pageStateMap.map.Profile);
        }
      })
    }) : page === pageStateMap.map.Profile ? /*#__PURE__*/_jsx(Box, {
      sx: {
        maxWidth: '70vw',
        width: 500,
        textAlign: 'center',
        mx: 'auto',
        maxHeight: 1
      },
      children: /*#__PURE__*/_jsx(OnboardingProfileForm, {
        profile: profile,
        onFinish: function onFinish() {
          return onSetPage(null);
        }
      })
    }) : null
  });
};
export default Object.assign(flow(useProps, PureOnboardingModal), {
  displayName: 'OnboardingModal'
});